module.exports = __webpack_public_path__ + "img/7945a8547930f89dc147174820a8770b.gif";